import "./TemplateTaskPanelTop.css";

import { ClosePanelArrowRightBlueIcon, TrashDark } from "../../../../assets";
import { SearchWorkflowTemplateTasksResponseTask } from "../../../../models";
import { Button } from "../../../../widget";

export interface TemplateTaskPanelTopProps {
  handleCloseTaskPanel: () => void;
  handleClickDeleteTemplateTask: () => void;
  canEditTask: boolean;
  templateTask: SearchWorkflowTemplateTasksResponseTask | undefined;
}

export const TemplateTaskPanelTop = ({
  handleCloseTaskPanel,
  handleClickDeleteTemplateTask,
  canEditTask,
  templateTask,
}: TemplateTaskPanelTopProps): JSX.Element => {
  return (
    <div className="TemplateTaskPanelTop">
      <Button
        text="Close panel"
        icon={<ClosePanelArrowRightBlueIcon className="CloseIcon" />}
        variant="secondary"
        onClick={handleCloseTaskPanel}
        minWidth={false}
        hasNoPadding
      />
      {canEditTask && templateTask && (
        <Button
          text=""
          icon={<TrashDark className="TrashIcon" />}
          variant="secondary"
          onClick={handleClickDeleteTemplateTask}
          minWidth={false}
          hasNoPadding
        />
      )}
    </div>
  );
};
